import { createSlice } from '@reduxjs/toolkit';
import { PAYMENT_METHODS } from 'bxcommon/constants/payments.constant';

const initialState = {
  case_id: '',
  last_edited: null,
  status: 1,
  additional_recipients: '',
  confirmations: {
    not_been_convicted: false,
    no_criminal_record: false,
    no_under_prohibition: false,
    all_information_correct: false,
    aware_of_obligations: false,
    electronic_delivery_allowed: false,
  },
  comment: '',
  approvals: {
    terms_of_use: false,
    rules_of_registration_office: false,
    list_of_fees: false,
  },
  payment: {
    method: PAYMENT_METHODS.CREDIT_CARD,
    voucher_code: null,
    status: null,
    paid_at: null,
    express_process: false,
    accepted_additional_fee_agreement: false,
  },

  // personal
  address_line_1: '',
  address_line_2: '',
  postcode: '',
  city: '',
  country: '',
  alternative_email: '',
  phone_number: '',
  phone_number_dial_code: '',
  work_phone_number: '',
  work_phone_number_dial_code: '',

  // express payment
  express_payment_needed: false,

  // fields of activity
  fields_of_activity: [],

  // education
  education: {
    proof_of_knowledge: false,
    proof_of_knowledge_professional_expertise: false,
    proof_of_knowledge_knowhow: false,
    proof_of_knowledge_declaration: false,
    degree: null,
    has_other_degree: false,
    other_degree: '',
    has_predefined_certificates: false,
    predefined_certificates: [],
    has_additional_certificates: false,
    additional_certificates: '',
    has_employer_confirmation: false,
    has_finsa_certificates: false,
    finsa_certificates: [],
    has_other_education: false,
    other_education: '',
  },

  // company / job / ombudsman office
  companies: [
    {
      type_of_employment: 1,
      id: null,
      name: '',
      address_line_1: '',
      address_line_2: '',
      postcode: '',
      city: '',
      country: null,
      ombudsman_offices: [],
      job_function: '',
      job_position: '',
      confirmation_of_employment_files: [],
      liability_insurance_files: [],
    },
  ],

  // documents
  passport_files: [],
  cv_files: [],
  criminal_record_extract_files: [],
  professional_or_academic_degree_files: [],
  predefined_certificate_files: [],
  additional_certificate_files: [],
  employer_confirmation_files: [],
  finsa_certificate_files: [],
};

const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    updateRequestField: (state, { payload }) => {
      return { ...state, ...payload };
    },
    clearForm: () => {
      return { ...initialState };
    },
    submitEntry: (state, { payload }) => {
      state.status = payload;
    },
  },
  extraReducers: (builder) => {
    // Listen for logout action from user.slice to clear form
    builder.addCase('user/clearFormOnLogout', () => {
      return { ...initialState };
    });
  },
});

export const { updateRequestField, clearForm, submitEntry } = requestSlice.actions;
export default requestSlice.reducer;
